import './Banner.css';

function Banner() {
    return (
        <header className="banner">
            <img src="/banner.png" alt="Banner principal do Organo"/>
        </header>
    );
}

export default Banner;